import type { OpenedPopover, PopoverName } from '@widgets/messenger/types/popover'
import { defineStore } from '@/composition/defineStore'
import { readonly, ref } from '@/composition/vue/compositionApi'

export const usePopoverStore = defineStore(Symbol('popoverStore'), () => {
  const openedPopover = ref<OpenedPopover<PopoverName> | null>(null)

  const setOpenedPopover = <T extends PopoverName>(popover: OpenedPopover<T> | null) => {
    openedPopover.value = popover
  }

  return {
    openedPopover: readonly(openedPopover),
    setOpenedPopover,
  }
})
